import React, { useState, useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import axios from "axios";

export default function SmsManage() {
    const toast = useRef(null);

    const [smsList, setSmsList] = useState([]);
    const [clients, setClients] = useState([]);
    const [messageType, setMessageType] = useState([]);
    const [branches, setBranches] = useState([]);
    const [visible, setVisible] = useState(false);
    const [editingSms, setEditingSms] = useState(null);
    const [globalFilter, setGlobalFilter] = useState("");
    const [filters, setFilters] = useState({
        clientid: null,
        branchid: null,
        messagetypeid: null
    });

    const [formData, setFormData] = useState({
        id: null,
        entity_id: "",
        api_key: "",
        template_id: "",
        user_id: "",
        sender_id: "",
        branch_title: "",
        location: "",
        mobile_number: "",
        owner_number: "",
        email_id: "",
        administrative_email: "",
        short_url: "",
        status: "Active"
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        fetchClients();
        fetchMessageType();
        fetchSmsList();
    }, []);

    const fetchClients = async () => {
        try {
            const res = await axios.get('https://treatway.co.in/Counter-Backend/api/server_masters/list/client_creation');
            setClients(res.data.map(c => ({ label: c.client_name, value: c.client_id })));
        } catch {
            toast.current.show({ severity: "error", summary: "Error", detail: "Failed to load clients" });
        }
    };

    const fetchBranches = async (clientId) => {
        try {
            const res = await axios.get('https://treatway.co.in/Counter-Backend/api/server_masters/branches', { params: { clientid: clientId } });
            setBranches(res.data.map(b => ({ label: b.branch_name, value: b.branch_id })));
        } catch {
            toast.current.show({ severity: "error", summary: "Error", detail: "Failed to load branches" });
        }
    };

    const fetchMessageType = async () => {
        try {
            const res = await axios.get('https://treatway.co.in/Counter-Backend/api/server_masters/list/sms_manage');
            setMessageType(res.data.map(m => ({ label: m.message_type, value: m.message_type_id })));
        } catch (err) {
            toast.current.show({ severity: "error", summary: "Error", detail: "Failed to load message type" });
        }
    };

    const fetchSmsList = async (appliedFilters = filters) => {
        try {
            const res = await axios.get('https://treatway.co.in/Counter-Backend/api/server_masters/list/sms_detail', { params: appliedFilters });

            if (res.data && res.data.status === "success" && Array.isArray(res.data.smsList)) {
                setSmsList(res.data.smsList);
            } else {
                setSmsList([]);
            }
        } catch (err) {
            console.error("Error fetching settings:", err);
            setSmsList([]);
            toast.current.show({ severity: "error", summary: "Error", detail: "Failed to load settings" });
        }
    };

    const handleFilterChange = (key, value) => {
        const newFilters = { ...filters, [key]: value };

        if (key === "clientid") {
            fetchBranches(value);
            newFilters.branchid = null;
        }

        setFilters(newFilters);
        fetchSmsList(newFilters);
    };

    const onInputChange = (e, name) => {
        const value = e.target.value;
        setFormData({ ...formData, [name]: value });

        let newErrors = { ...errors };

        if (name === "email_id" || name === "administrative_email") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailRegex.test(value)) {
                delete newErrors[name];
            }
        } else if (name === "mobile_number" || name === "owner_number") {
            const mobileRegex = /^[0-9]{10}$/;
            if (mobileRegex.test(value)) {
                delete newErrors[name];
            }
        } else if (name === "short_url") {
            const urlRegex = /^(https?:\/\/[^\s]+)$/;
            if (urlRegex.test(value)) {
                delete newErrors[name];
            }
        } else {
            if (value.trim() !== "") {
                delete newErrors[name];
            }
        }

        setErrors(newErrors);
    };


    // Validation
    const validateForm = () => {
        let newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobileRegex = /^[0-9]{10}$/;
        const urlRegex = /^(https?:\/\/[^\s]+)$/;

        // Define only required fields
        const requiredFields = [
            "entity_id",
            "api_key",
            "template_id",
            "user_id",
            "sender_id",
            "mobile_number",
            "status"
        ];

        requiredFields.forEach((key) => {
            if (!formData[key] || !formData[key].toString().trim()) {
                newErrors[key] = "This field is required";
            }
        });

        // Specific validations
    /*    if (formData.mobile_number && !mobileRegex.test(formData.mobile_number)) {
            newErrors.mobile_number = "Invalid mobile number (10 digits required)";
        }

        if (formData.owner_number && !mobileRegex.test(formData.owner_number)) {
            newErrors.owner_number = "Invalid owner mobile number (10 digits required)";
        } 

        if (formData.email_id && !emailRegex.test(formData.email_id)) {
            newErrors.email_id = "Invalid email format";
        }*/

        if (formData.administrative_email && formData.administrative_email.trim() !== "" && !emailRegex.test(formData.administrative_email)) {
            newErrors.administrative_email = "Invalid administrative email format";
        }

        if (formData.short_url && formData.short_url.trim() !== "" && !urlRegex.test(formData.short_url)) {
            newErrors.short_url = "Invalid URL format";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // open dialog for edit
    const editSms = (rowData) => {
        setEditingSms(true);
        setFormData({
            id: rowData.auth_id,
            entity_id: rowData.enitity_id,
            api_key: rowData.api_key,
            template_id: rowData.template_id,
            user_id: rowData.user_id,
            sender_id: rowData.sender_id,
            branch_title: rowData.branch_title,
            location: rowData.location,
            mobile_number: rowData.mobile_no,
            owner_number: rowData.owner_num,
            email_id: rowData.email_id,
            administrative_email: rowData.adminstrative_email,
            short_url: rowData.shorts_url,
            status: rowData.status
        });
        setVisible(true);
    };

    const saveSms = async () => {
        if (!validateForm()) {
            toast.current.show({ severity: "error", summary: "Validation Error", detail: "Please fix errors before saving" });
            return;
        }

        try {
            const url = editingSms ? 'https://treatway.co.in/Counter-Backend/api/server_masters/save/sms_detail' : 'https://treatway.co.in/Counter-Backend/api/server_masters/save/sms_detail';

           // await axios.post(url, formData);
           await axios.post(url, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            toast.current.show({
                severity: "success",
                summary: "Success",
                detail: editingSms ? "SMS Config Updated" : "SMS Config Added"
            });

            setVisible(false);
            setEditingSms(null);
            setFormData({
                id: null,
                entity_id: "",
                api_key: "",
                template_id: "",
                user_id: "",
                sender_id: "",
                branch_title: "",
                location: "",
                mobile_number: "",
                owner_number: "",
                email_id: "",
                administrative_email: "",
                short_url: "",
                status: "Active"
            });
            fetchSmsList();
        } catch (err) {
            console.error(err);
            toast.current.show({ severity: "error", summary: "Error", detail: "Something went wrong" });
        }
    };

    const dialogFooter = (
        <div>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={() => setVisible(false)} />
            <Button label="Save" icon="pi pi-check" onClick={saveSms} />
        </div>
    );

    const statusOptions = [
        { label: "Active", value: "Active" },
        { label: "InActive", value: "InActive" }
    ];

    return (
        <>
            <Toast ref={toast} />
            <h2 className="text-xl font-bold mb-4">SMS Management</h2>
            <div className="card">
                <div className="flex flex-wrap gap-4 mt-3 align-items-end">
                    <div className="flex flex-column" style={{ flex: 1, minWidth: '180px' }}>
                        <label className="mb-1 font-medium">Client</label>
                        <Dropdown
                            value={filters.clientid}
                            options={clients}
                            onChange={(e) => handleFilterChange("clientid", e.value)}
                            placeholder="Select Client"
                            className="w-full"
                            filter
                        />
                    </div>
                    <div className="flex flex-column" style={{ flex: 1, minWidth: '180px' }}>
                        <label className="mb-1 font-medium">Branch</label>
                        <Dropdown
                            value={filters.branchid}
                            options={branches}
                            onChange={(e) => handleFilterChange("branchid", e.value)}
                            placeholder="Select Branch"
                            className="w-full"
                            filter
                        />
                    </div>
                    <div className="flex flex-column" style={{ flex: 1, minWidth: '180px' }}>
                        <label className="mb-1 font-medium">Message Type</label>
                        <Dropdown
                            value={filters.messagetypeid}
                            options={messageType}
                            onChange={(e) => handleFilterChange("messagetypeid", e.value)}
                            placeholder="Select Message Type"
                            className="w-full"
                            filter
                        />
                    </div>
                    <div className="flex flex-column" style={{ flex: 1, minWidth: '180px' }}>
                        <label className="mb-1 font-medium"></label>
                        <Button
                            label="Reset Filters"
                            icon="pi pi-refresh"
                            className="p-button-secondary"
                            onClick={() => {
                                const resetFilters = { clientid: null, branchid: null, messagetypeid: null };
                                setFilters(resetFilters);
                                setBranches([]);
                                fetchSmsList(resetFilters);
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="flex flex-wrap justify-between items-center mb-4 gap-3">
                    <span className="p-input-icon-left ml-auto w-full sm:w-auto min-w-[250px]">
                        <i className="pi pi-search"></i>
                        <InputText
                            value={globalFilter}
                            onChange={(e) => setGlobalFilter(e.target.value)}
                            placeholder="Search..."
                            className="p-inputtext-sm w-full"
                        />
                    </span>
                </div>

                <DataTable value={smsList}
                    showGridlines
                    paginator
                    rows={25}
                    rowsPerPageOptions={[10, 25, 50]}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    tableStyle={{ minWidth: '60rem' }}
                    className="p-datatable-sm relative"
                    emptyMessage="No SMS Configs found."
                    globalFilter={globalFilter}
                >
                    <Column field="client_name" header="Client" />
                    <Column field="branch_name" header="Branch" />
                    <Column field="message_type" header="Message Type" />
                    <Column field="enitity_id" header="Entity ID" />
                    <Column field="api_key" header="API Key" />
                    <Column field="template_id" header="Template ID" />
                    <Column field="sender_id" header="Sender ID" />
                    <Column field="mobile_no" header="Mobile" />
                    <Column
                        field="status"
                        header="Status"
                        body={(rowData) => (
                            <span
                                className={`px-2 py-1 text-sm font-semibold border-round text-white ${
                                    rowData.status === "Active" ? "bg-green-500" : "bg-orange-500"
                                }`}
                            >
                                {rowData.status}
                            </span>
                        )}
                    />
                    <Column
                        header="Actions"
                        body={(rowData) => (
                            <Button
                                icon="pi pi-pencil"
                                className="p-button-rounded p-button-warning mr-2"
                                onClick={() => editSms(rowData)}
                            />
                        )}
                    />
                </DataTable>

                <Dialog
                    header={editingSms ? "Edit SMS Config" : "Add SMS Config"}
                    visible={visible}
                    style={{ width: "800px" }}
                    footer={dialogFooter}
                    onHide={() => setVisible(false)}
                >
                    <div className="formgrid grid">
                        <div className="field col-12 md:col-12">
                            <label htmlFor="status">Status</label>
                            <Dropdown
                                id="status"
                                value={formData.status}
                                options={statusOptions}
                                onChange={(e) => setFormData({ ...formData, status: e.value })}
                                className="w-full"
                            />
                            {errors.status && <small className="p-error">{errors.status}</small>}
                        </div>

                        {/* API / IDs */}
                        {["entity_id", "api_key", "template_id", "user_id", "sender_id"].map((key) => (
                            <div className="field col-12 md:col-6" key={key}>
                                <label htmlFor={key}>{key.replace(/_/g, " ").toUpperCase()}</label>
                                <InputText
                                    id={key}
                                    value={formData[key]}
                                    onChange={(e) => onInputChange(e, key)}
                                    className="w-full"
                                />
                                {errors[key] && <small className="p-error">{errors[key]}</small>}
                            </div>
                        ))}

                        {/* Branch & Location */}
                        {["branch_title", "location"].map((key) => (
                            <div className="field col-12 md:col-6" key={key}>
                                <label htmlFor={key}>{key.replace(/_/g, " ").toUpperCase()}</label>
                                <InputText
                                    id={key}
                                    value={formData[key]}
                                    onChange={(e) => onInputChange(e, key)}
                                    className="w-full"
                                />
                                {errors[key] && <small className="p-error">{errors[key]}</small>}
                            </div>
                        ))}

                        {/* Contacts */}
                        {["mobile_number", "owner_number", "email_id", "administrative_email"].map((key) => (
                            <div className="field col-12 md:col-6" key={key}>
                                <label htmlFor={key}>{key.replace(/_/g, " ").toUpperCase()}</label>
                                <InputText
                                    id={key}
                                    value={formData[key]}
                                    onChange={(e) => onInputChange(e, key)}
                                    className="w-full"
                                />
                                {errors[key] && <small className="p-error">{errors[key]}</small>}
                            </div>
                        ))}

                        {/* Short URL */}
                        <div className="field col-12 md:col-6">
                            <label htmlFor="short_url">Short URL</label>
                            <InputText
                                id="short_url"
                                value={formData.short_url}
                                onChange={(e) => onInputChange(e, "short_url")}
                                className="w-full"
                            />
                            {errors.short_url && <small className="p-error">{errors.short_url}</small>}
                        </div>
                    </div>
                </Dialog>


            </div>
        </>
    );
}
